'use client'

import { Card, CardContent } from '@/components/ui/card'
import { Separator } from '@/components/ui/separator'
import { MapPin } from 'lucide-react'
import { FadeUp } from '@/components/ui/fade-up'

export function CompanyInfoSection() {
    return (
        <section className="py-16">
            <div className="container">
                <FadeUp>
                    <h2 className="text-3xl font-bold text-center mb-12">会社概要</h2>

                    <Card className="max-w-4xl mx-auto">
                        <CardContent className="p-8">
                            <div className="space-y-6">
                                <div className="grid md:grid-cols-2 gap-x-8 gap-y-6">
                                    <div>
                                        <p className="text-sm text-muted-foreground mb-1">会社名</p>
                                        <p className="font-medium">株式会社CodeFox</p>
                                    </div>
                                    <div>
                                        <p className="text-sm text-muted-foreground mb-1">設立</p>
                                        <p className="font-medium">2022年8月19日</p>
                                    </div>
                                    <div>
                                        <p className="text-sm text-muted-foreground mb-1">代表取締役 / Security Lead</p>
                                        <p className="font-medium">進藤 史裕</p>
                                        <p className="text-sm text-muted-foreground mt-1">情報処理安全確保支援士（RISS / 登録番号020238）</p>
                                    </div>
                                    <div>
                                        <p className="text-sm text-muted-foreground mb-1">事業内容</p>
                                        <p className="font-medium">地域DXソリューションの開発・提供</p>
                                        <p className="text-sm text-muted-foreground mt-1">セキュリティ評価・脆弱性診断</p>
                                    </div>
                                </div>

                                <Separator />

                                <div>
                                    <p className="text-sm text-muted-foreground mb-2">本社所在地</p>
                                    <div className="flex items-start gap-2">
                                        <MapPin className="h-5 w-5 text-muted-foreground shrink-0 mt-0.5" />
                                        <div>
                                            <p className="font-medium">〒730-0053</p>
                                            <p className="font-medium">広島県広島市中区東千田町1丁目1番61号hitoto広島ナレッジスクエア1F</p>
                                        </div>
                                    </div>
                                </div>

                                <Separator />

                                <div>
                                    <p className="text-sm text-muted-foreground mb-2">拠点</p>
                                    <div>
                                        <p className="font-medium mb-1">Digital Pride Hiroshima</p>
                                        <p className="text-sm text-muted-foreground">広島県広島市中区東千田町1丁目1番61号hitoto広島ナレッジスクエア1F</p>
                                    </div>
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                </FadeUp>
            </div>
        </section>
    )
}
